import React from "react";
import styled from "styled-components";

function FilterInfo({ info, onClearClick }) {
  if (!info || Object.keys(info).length === 0) {
    return null;
  }
  return (
    <Wrap>
      <div className="text-primary ml-2">{info}</div>
      {onClearClick && (
        <div
          className="text-primary mr-2"
          onClick={e => {
            e.stopPropagation();
            onClearClick();
          }}
        >
          Clear
        </div>
      )}
    </Wrap>
  );
}

const Wrap = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
`;

export default FilterInfo;
